module.exports = __webpack_public_path__ + "img/service-software-1.884cf139.jpg";